<i18n src="@/locales/views/agro_exporter/production/basic_container_export/edit_planning.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container_planning.yml" lang="yaml"></i18n>
<template>
  <go-back-link
    :text="$t('labels.go-back-link')"
    name="ae_production_basic_container_export_show_container_path"
    :params="{
      agro_exporter_process_id: agro_exporter_process_id,
      container_id: container_id,
    }"
  />

  <agro-exporter-process-header
    :agro_exporter_process_id="agro_exporter_process_id"
  />

  <template v-if="load_general_data">
    <container-info
      :container="container"
      :show_container_code="true"
    ></container-info>

    <alert-danger class="mt-8" :errors_data="std_err" />

    <div class="mt-8">
      <div class="panel">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div class="space-y-8 divide-y divide-slate-200" v-if="planning">
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div class="sm:col-span-2">
                <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                  <div class="sm:col-span-6">
                    <label
                      :class="[
                        'label-form',
                        isInvalidLabel('num_package_groups'),
                      ]"
                    >
                      {{ $t("model.container_planning.num_package_groups") }}
                    </label>
                    <div class="mt-1">
                      <input
                        type="text"
                        v-model.number="planning.num_package_groups"
                        :class="['input-text', isInvalid('num_package_groups')]"
                      />
                    </div>
                  </div>
                  <div class="sm:col-span-6">
                    <label
                      :class="['label-form', isInvalidLabel('packages_per_pg')]"
                    >
                      {{ $t("model.container_planning.packages_per_pg") }}
                    </label>
                    <div class="mt-1">
                      <input
                        type="text"
                        v-model.number="planning.packages_per_pg"
                        :class="['input-text', isInvalid('packages_per_pg')]"
                      />
                    </div>
                  </div>
                  <div class="sm:col-span-6">
                    <template v-if="num_total_packages">
                      <label
                        :class="[
                          'label-form',
                          isInvalidLabel('num_total_packages'),
                        ]"
                      >
                        {{ $t("model.container_planning.num_total_packages") }}
                      </label>
                      <div class="mt-1">
                        {{ num_total_packages }}
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="sm:col-span-4">
                <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                  <div class="sm:col-span-6">
                    <label class="label-form"> Detalle de cajas </label>
                    <div class="mt-1">
                      <package-detail-selector
                        v-model="planning.package_detail_id"
                      />
                    </div>
                  </div>
                  <div class="sm:col-span-6">
                    <template v-if="planning.package_detail_id">
                      <div class="sm:col-span-4">
                        <div v-show="is_detailed_per_pg">
                          <package-group-plannings-input
                            v-model="package_group_plannings"
                            :brands="brands"
                            :sizes="sizes"
                            :default_agro_exporter_brand_id="default_agro_exporter_brand_id"
                          />
                        </div>
                        <div v-show="is_detailed_per_package">
                          <package-plannings-input
                            v-model="package_plannings"
                            :brands="brands"
                            :sizes="sizes"
                            :default_agro_exporter_brand_id="default_agro_exporter_brand_id"
                          />
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
              <div class="sm:col-span-6">
                <label class="label-form">
                  {{ $t("model.container_planning.observations") }}
                </label>
                <div class="mt-1">
                  <textarea
                    v-model="planning.observations"
                    rows="3"
                    class="input-text-area"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-footer">
          <div class="panel-footer-actions">
            <white-button
              @click.prevent="goToShowContainer()"
              :label="$t('labels.cancel_button')"
            />
            <span class="space-actions"></span>
            <success-button
              v-if="!proc_save_button"
              @click.prevent="submit"
              :label="$t('labels.save_button')"
            />
            <success-button-processing
              v-else
              :label="$t('labels.save_button')"
            />
          </div>
        </div>
      </div>
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/production/basic_container_export/manage_container_planning.js";
import AgroExporterProcessHeader from "@/components/views/agro_exporter/production/basic_container_export/AgroExporterProcessHeader.vue";
import PackageDetailSelector from "@/components/views/agro_exporter/production/basic_container_export/container_planning/PackageDetailSelector.vue";
import PackagePlanningsInput from "@/components/views/agro_exporter/production/basic_container_export/container_planning/PackagePlanningsInput.vue";
import PackageGroupPlanningsInput from "@/components/views/agro_exporter/production/basic_container_export/container_planning/PackageGroupPlanningsInput.vue";
import ContainerInfo from "@/components/views/agro_exporter/production/basic_container_export/ContainerInfo.vue";
import ManagePlanningMixin from "@/components/views/agro_exporter/production/basic_container_export/container_planning/manage_planning.js";

export default {
  name: "AEProductionBasicContainerExportNewContainer",
  components: {
    AgroExporterProcessHeader,
    PackageDetailSelector,
    PackagePlanningsInput,
    PackageGroupPlanningsInput,
    ContainerInfo,
  },
  mixins: [ManagePlanningMixin],
  props: ["agro_exporter_process_id", "container_id", "agro_exporter_id"],
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      container: {},
    };
  },
  methods: {
    fetchData: async function () {
      await this.fetchContainerPlanning();
      await this.fetchContainer();
      await this.fetchCropSizes();
      await this.fetchExporterProcessBrands();
      this.load_general_data = true;
    },
    fetchContainer: async function () {
      let response = await Requester.fetchContainer(this.container_id);
      this.container = response.data;
    },
    fetchCropSizes: async function () {
      let response = await Requester.fetchCropSizes(
        this.agro_exporter_process_id
      );
      this.sizes = response.data;
    },
    fetchContainerPlanning: async function () {
      let response = await Requester.fetchContainerPlanning(this.container_id);
      this.planning = response.data;
      this.package_plannings = this.planning.package_plannings || [];
      this.package_group_plannings =
        this.planning.package_group_plannings || [];
    },
    fetchExporterProcessBrands: async function () {
      let response = await Requester.fetchAgroExporterBrands(
        this.agro_exporter_process_id
      );
      this.brands = response.data;
      // if (this.brands.length == 1)
      //   this.container.exporter_process_brand_id = this.brands[0].id;
    },
    goToShowContainer: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_show_container_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: this.container_id,
        },
      });
    },
    submit: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.update({
          container_id: this.container_id,
          container_planning: this.params,
          package_plannings: this.filtered_package_plannings,
          package_group_plannings: this.filtered_package_group_plannings,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowContainer();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.proc_save_button = false;
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fetchData();
      })
    );
  },
};
</script>
